import { connection_platform } from "../services/api/configConnection";

const urlIngWeb = connection_platform.urlProjectIngWeb;

export default urlIngWeb;
